import { usePlacesStore,useMapStore } from "@/composables";
import { defineComponent, ref, onMounted, watch, computed } from 'vue';
import Mapboxgl from "mapbox-gl";
import SearchResults from "../search-results/searchResults.vue";



export default defineComponent({
    name: 'SearchBar',
    components: { SearchResults },
    setup() {
        const { searchPlacesByTerm} = usePlacesStore()
        const debounceValued = ref ('')
        const debounceTimeout = ref ()

        return {
            debounceValued,
            searchTerm : computed ({
                get() { return debounceValued.value },
                set( val : string) {
                    if(debounceTimeout.value ) clearTimeout( debounceTimeout.value )
                    debounceTimeout.value = setTimeout( () =>{
                        debounceValued.value = val
                        searchPlacesByTerm( val )
                    },1000) 
                 } 

            }) 
        }

    }
})